module.exports = __webpack_public_path__ + "static/media/devoto.9c0b54bc.jpg";